<template>
    <div id="tab-training" class="tab" style="display: block;"><p>Lorem ipsum</p></div>
</template>

<script>

    export default {
        name: 'current-employee-study',
        data() {
            return {

            }
        },
        props: {
            employee: Object,
        },
        methods: {

        },
    }
</script>

<style scoped>

</style>
